import styled from "styled-components";

/**
 * (routes) 共通スタイル
 * - レイアウト用: Wrap, Container, Main, Footer → layout.js で使用
 * - ページコンテンツ用: PageWrap, PageTitle → 各ルートの styles.js で利用し、個別スタイルと組み合わせる
 */

const Container = styled.div`
  padding: 0 15px 50px;
  width: 100%;
  min-width: 1480px;
  margin-left: 10px;
  height: auto;
  min-height: 100vh;
  flex: 1;
  display: flex;
  flex-direction: column;
  order: 1;
`;

/** 各ページのコンテンツラップ（共通） */
const PageWrap = styled.div`
  width: 100%;
  padding: 1.5rem 0;
`;

/** 各ページのタイトル（共通） */
const PageTitle = styled.h1`
  margin: 0;
  font-size: 1.75rem;
  font-weight: 600;
  color: #3d3a36;
  letter-spacing: 0.02em;
`;

const Styles = {
  Wrap: styled.div`
    width: 100%;
    position: relative;
    height: 100vh;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    background-color: white;
    border-radius: 12px;

    font-family: "ヒラギノ角ゴ Pro W3", "Hiragino Kaku Gothic Pro", "メイリオ", Meiryo, Osaka, "ＭＳ Ｐゴシック", "MS PGothic", sans-serif;
  `,
  Container,
  Main: styled.div`
    min-height: 120px;
    padding: 0 0 0px;
    position: relative;
    flex: 1;
    background-color: white;
    border-radius: 10px;
    padding: 10px;
  `,
  Footer: styled.div`
    flex-shrink: 0;
    order: 2;
    width: 100vw;
    max-width: 100vw;
    /* 親の幅制限を抜けて画面横幅全体に表示 */
    margin-left: calc(50% - 50vw);
    box-sizing: border-box;
  `,
  PageWrap,
  PageTitle,
};

export default Styles;
